//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { LayoutContext } from '../../common/contexts';
//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
// import SearchInput from './SearchInput';
// import AfitdButton from '../../common/elemental/AfitdButton';
// import RotateLeftIcon from '@material-ui/icons/RotateLeft';
// import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ActivityStatsTableHire, { EnhancedTableToolbar } from './Tables/ActivityStatsTableHire';
import ActivityStatsTableAppliedJobs from './Tables/ActivityStatsTableAppliedJobs';
import ActivityStatsTableInterviewData from './Tables/ActivityStatsTableInterviewData';
//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
        headerTitle: { fontWeight: 'bold', fontSize: 20 },
        topBarRightItem: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' },
        passwordResetButton: { height: 36, marginRight: 8 },
        selectedText: { paddingRight: 16 },
        deleteButton: { height: 36 },
        topBarContainer: { height: 57.66, border: '1px solid #F3F3F3', padding: '0px 10px', width: 1084, marginLeft: '-2px', borderRadius: '4px 4px 0px 0px' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        selected,
        setSelected,
        userType,
        setUserType,
        country,
        setCountry,
        isHire,
        setIsHire,
        isJobsApplied,
        setIsJobsApplied,
        isInterviewData,
        setIsInterviewData,
        setPage,
    } = params;

    const defns = {
        root: { item: true, xl: 9, lg: 9, md: 9, sm: 9, xs: 9 },
        passwordResetButton: { color: 'secondary' },
        topBarContainer: { container: true, alignItems: 'center' },
        topBarLeftItem: { item: true, xl: 7, xs: 7 },
        topBarRightItem: { item: true, xl: 5, xs: 5 },
        selectedText: { color: 'secondary' },
        statsTableProps: {
            selected,
            setSelected,
            userType,
            setUserType,
            country,
            setCountry,
            isHire,
            setIsHire,
            isJobsApplied,
            setIsJobsApplied,
            isInterviewData,
            setIsInterviewData,
            setPage,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ActivityStats = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    // const layoutContext = useContext(LayoutContext);
    // const { scrollToPageTop } = layoutContext;
    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states

    //---------------------------------------------------------------------
    const [selected, setSelected] = useState([]);
    const [userType, setUserType] = useState('EMP');
    const [country, setCountry] = useState('United States');
    const [page, setPage] = React.useState('hire');
    const [isHire, setIsHire] = React.useState(true);
    const [isJobsApplied, setIsJobsApplied] = React.useState(false);
    const [isInterviewData, setIsInterviewData] = React.useState(false);
    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        selected,
        setSelected,
        userType,
        setUserType,
        country,
        setCountry,
        isHire,
        setIsHire,
        isJobsApplied,
        setIsJobsApplied,
        isInterviewData,
        setIsInterviewData,
        setPage,
    });

    //---------------------------------------------------------------------
    // Helper functions
    //---------------------------------------------------------------------
    const getLayoutComponent = () => {
        switch (page) {
            case 'hire':
                return <ActivityStatsTableHire {...defns.statsTableProps} />;
            case 'jobApplied':
                return <ActivityStatsTableAppliedJobs {...defns.statsTableProps} />;
            case 'interviewData':
                return <ActivityStatsTableInterviewData {...defns.statsTableProps} />;
            default:
                return <ActivityStatsTableHire {...defns.statsTableProps} />;
        }
    };
    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.root}>
            <div>
                <p {...defns.headerTitle}>Activity Stats</p>
            </div>
            <div>
                <EnhancedTableToolbar setUserType={setUserType} page={page} userType={userType} setPage={setPage} />
                {getLayoutComponent()}
            </div>
        </Grid>
    );
};

export default ActivityStats;
